var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotActual(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    viewBox: "0 1 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    fill: "#C8D4D8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m27 29h-2v-6.26a3 3 0 0 0 -.722-1.952l-3.546-4.137a1 1 0 0 1 0-1.3l3.546-4.137a3 3 0 0 0 .722-1.954v-6.26h2a1 1 0 0 0 0-2h-22a1 1 0 0 0 0 2h2v6.26a3 3 0 0 0 .722 1.952l3.546 4.137a1 1 0 0 1 0 1.3l-3.546 4.139a3 3 0 0 0 -.722 1.952v6.26h-2a1 1 0 0 0 0 2h22a1 1 0 0 0 0-2zm-15-4h8a1 1 0 0 1 0 2h-8a1 1 0 0 1 0-2z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotActual);
export default __webpack_public_path__ + "static/media/not-actual.624ed3e0c8cb9cc5029d5f191e895b40.svg";
export { ForwardRef as ReactComponent };